import styled from 'styled-components'
import FooterSimple from '../../../../components/Footers/FooterSimple/FooterSimple'

export const MapBoxWrapper = styled.div`
  position: fixed;
  text-align: left;
  height: 100dvh;
  width: 100vw;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;

  .mapboxgl-ctrl-pitchtoggle-3d {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCI+ICAgIDx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkeT0iLjM1ZW0iIHN0eWxlPSJmb250LXNpemU6IDE0cHg7IGZvbnQtZmFtaWx5OiAnSGVsdmV0aWNhIE5ldWUnLEFyaWFsLEhlbHZldGljYSxzYW5zLXNlcmlmOyBmb250LXdlaWdodDogYm9sZDsgdGV4dC1hbmNob3I6IG1pZGRsZTsiPjNEPC90ZXh0Pjwvc3ZnPg==);
  }

  .mapboxgl-ctrl-pitchtoggle-2d {
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCI+ICAgIDx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBkeT0iLjM1ZW0iIHN0eWxlPSJmb250LXNpemU6IDE0cHg7IGZvbnQtZmFtaWx5OiAnSGVsdmV0aWNhIE5ldWUnLEFyaWFsLEhlbHZldGljYSxzYW5zLXNlcmlmOyBmb250LXdlaWdodDogYm9sZDsgdGV4dC1hbmNob3I6IG1pZGRsZTsiPjJEPC90ZXh0Pjwvc3ZnPg==);
  }

  .mapboxgl-ctrl-flyhome {
    background-image: url(data:image/svg+xml;base64,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);
  }

  .maplibregl-popup-content,
  .mapboxgl-popup-content {
    padding: 0;
    background: none;
  }
`

export const MapFooter = styled(FooterSimple)`
  position: absolute;
  bottom: 0;
  background: white;
  width: auto;
  padding: 0px 10px;
  margin: 0 50px 0 0;
  a {
    display: none;
  }
  > div {
    display: flex;
    margin: 0;
    p {
      width: auto;
      margin: 2px 10px 2px 0;
    }
    span {
      margin: 2px 0 2px 0;
    }
  }
`
